import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import type { ChartDataPoint, BatchSuccessRateEntry } from './types';

interface ProgressStatsProps {
  chartData: ChartDataPoint[];
  successRates: BatchSuccessRateEntry[];
  calculateImprovement: (data: ChartDataPoint[], metric: keyof ChartDataPoint) => string;
}

const ProgressStats: React.FC<ProgressStatsProps> = ({ chartData, successRates, calculateImprovement }) => {
  const avgSuccessRate = successRates.length > 0
    ? Math.round((successRates.reduce((sum, r) => sum + r.successRate, 0) / successRates.length) * 100)
    : null;
  const successColor = avgSuccessRate !== null
    ? (avgSuccessRate > 80 ? '#2e7d32' : avgSuccessRate > 50 ? '#ed6c02' : '#d32f2f')
    : '#9e9e9e';

  const stats = [
    { label: 'Обем', value: calculateImprovement(chartData, 'totalVolume'), color: '#42a5f5' },
    { label: 'Макс Тегло', value: calculateImprovement(chartData, 'maxWeight'), color: '#66bb6a' },
    { label: 'Ср. Повторения', value: calculateImprovement(chartData, 'avgReps'), color: '#ffa726' },
    { label: 'Средно RPE', value: calculateImprovement(chartData, 'avgRPE'), color: '#ef5350' },
  ];

  if (avgSuccessRate !== null) {
    stats.push({ label: 'Успеваемост', value: `${avgSuccessRate}%`, color: successColor });
  }

  return (
    <Box className="progress-stats" sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2 }}>
      {stats.map((stat) => (
        <Card key={stat.label} className="progress-stat-card" sx={{ borderLeft: `3px solid ${stat.color}` }}>
          <CardContent className="progress-stat-card-content" sx={{ textAlign: 'center', p: '12px !important', '&:last-child': { pb: '12px !important' } }}>
            <Typography className="progress-stat-label" variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: 0.5 }}>
              {stat.label}
            </Typography>
            <Typography className="progress-stat-value" variant="h4" sx={{ fontWeight: 'bold', color: stat.color, lineHeight: 1.2, mt: 0.5 }}>
              {stat.value}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default ProgressStats;
